<template>
	<section>
		<titlebar :title-stack="titleStack"></titlebar>
		<div class="columns box">
			<div class="column is-3">
				<b-field>
					<b-select v-model="projetistaFiltro" 
							:disabled="isProjetista()"
							:placeholder="$t('SISTEMA.PROJETISTA')" 
							@input="loadAsyncData()" expanded>
						<option :value="null"></option>
						<template v-for="(item, index) in this.listaProjetistasUnidade">
							<option v-if="projetistaFiltro == item.id" selected v-bind:key="index" :value="item.id">
								{{item.nome}}
							</option>
							<option v-else v-bind:key="index" :value="item.id">
								{{item.nome}}
							</option>
						</template>
					</b-select>              
				</b-field>
			</div>
		</div>
		<br/>
		<div v-if="isLoading">
			<b-loading active></b-loading>
		</div>
		<div v-else>
			<div class="columns is-multiline">
				<div
					v-for="(card, index) in cards"
					:key="index"
					class="column is-2"
				>
					<p class="title is-size-5 has-text-centered is-4">
						{{ card.title }}
					</p>
					<div @click="navigateTo(card)" class="card custom-card is-flex is-flex-direction-column has-text-centered">
						<div class="card-content px-0">
							<div class="content has-text-white">
								<span v-if="card.quantidade"
									:class="getClass(card)">
									{{ card.quantidade }}
								</span>
								<div v-if="card.valorTotal">
									{{ card.valorTotal }}
								</div>
								<div v-if="card.title == 'Vendas no ano' && card.media">
									{{ card.media }} T
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</section>
</template>

<style scoped>
	.custom-card {
		background-color: #000 !important;
		border-radius: 15px !important;
		margin: 8px;
		min-height: 7.5rem;
		transition: transform 0.3s ease, background-color 0.3s ease;
	}

	.custom-card:hover {
		transform: scale(1.1);
		background-color: rgba(0, 0, 0, 0.95) !important;
		cursor: pointer;
	}

	.content {
		font-size: 1rem;
		line-height: 1.5;
	}
</style>

<script>
	import titlebar from "@/components/titlebar.vue";
	import { mapState } from "vuex";

	export default {
		data() {
			return {
				isLoading: false,
				listaProjetistasUnidade: [],
				projetistaFiltro:  this.$route.query?.funcionarioId ?? null, 
				cards: [],
			};
		},
		components: {
			titlebar,
		},
		computed: {
			titleStack() {
				return [
					"Relatório",
					"Dashboard",
					"Projetistas"
				];
			},
			...mapState(
				[
					"usuario",
					"unidadeId"
				]
			),
		},
        watch: {            
            unidadeId: function(novaUnidade) {                 
                this.carregarProjetistasUnidade();
				this.cards= [];
            },
        }, 		
		mounted() {
			this.carregarProjetistasUnidade();

			if(this.isProjetista()){
				this.projetistaFiltro = this.usuario.funcionarioId
				this.loadAsyncData();
			}
		},
		methods: {
			async loadAsyncData() {
				await this.carregarDados();
			},
			isProjetista() {
				return (
					this.usuario.nivel == "Projetista" ||
					this.usuario.nivel.includes("Projetista")
				);
			},
			carregarDados() {
				const params = [];
				
				if(this.projetistaFiltro > 0 ){
					params.push(`funcionarioId=${this.projetistaFiltro}`);
					params.push(`unidadeId=${this.unidadeId}`)
					params.push(`isProjetista=${true}`)

					this.isLoading = true;
					
					this.$http.get(`/api/relatorio/DashboardProjetista?${params.join('&')}`)
							.then(res => res.data)
							.then(data => {
							this.cards = data						
						})
						.catch((error) => {
							throw error
						})
						.finally(() => {
							this.isFetching = false;
							this.isLoading = false;
						})					
				}

			},
			carregarProjetistasUnidade(){
				this.$http.get('/api/search/FuncionarioProjetista?unidadeId='+this.unidadeId)
				.then(res => res.data)
				.then(data => {
					if (data != null) {
						this.listaProjetistasUnidade = data;
					}
                }).finally(() => {  
                    this.loadAsyncData();
                });
			},
			getClass(card) {
				if (card.quantidade.includes('%')) {
					const quantidade = parseFloat(card.quantidade.replace('%', '').trim());
					if (quantidade >= 80) {
						return 'has-text-info';
					} 
					else if (quantidade < 80 && quantidade > 30) {
						return 'has-text-warning';
					}
					else{
						return 'has-text-danger';
					}
				}

				return '';
			},
			navigateTo(card) {
				if (card.title != 'Meta Mensal') {
					this.$router.push({ name: 'cardlist', query: this.defineParams(card) });
				}
			},
			defineParams(card) {
				const params = {
					fromDashboard: 'Projetistas',
					card: card.title,
					funcionarioId: this.projetistaFiltro,
					isProjetista: true,
					isVendedor:false,
					isConferente: false					
				};

				return params;
			}
		},
	};
</script>